<template>
  <scroll-right-frame>
    <div class="rp-wrapper">
      <div class="rp-header">
        <span class="rp-header-title">消息接收，频道：{{ wsChannel }}</span>
      </div>
      <div class="rp-body">
        消息列表：
        <div>
          <el-alert
            v-for="(m, index) in messageList"
            :key="index"
            :title="m"
            type="success"
            style="margin-top: 6px;"
          >
          </el-alert>
        </div>
      </div>
      <div class="rp-footer">
      </div>
    </div>
  </scroll-right-frame>
</template>
<script>
  import ws from '../../../../websocket'
  import ScrollRightFrame from '../../../../components/scroll-right-frame'
  export default {
    name: 'test-ws-receiver2',
    components: {ScrollRightFrame},
    data() {
      return {
        wsChannel: 'test-ws-channel-2',
        messageList: []
      }
    },
    mounted() {
      ws.registerObserver(this.wsChannel, this)
    },
    beforeDestroy() {
      ws.removeObserver(this.wsChannel, this)
    },
    methods: {
      onMessage(data) {
        this.messageList.push(data.data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/custom/components/demo/websocket/test-ws-receiver2.vue